import { Component, useState, useEffect,useRef } from 'react';
import styles from './style.module.css';
import NaviButton from '../../compoenets/NaviButton';
import DeviceClusteringChart from './DeviceClusteringChart'
import useApi from '../../services/useApi';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { newTaskConfig } from '../../recoil/atoms';
import StepSlider from './StepSlider';

const MainItem = ({title,subTitle=null,children})=>{
  return(
    <div className={styles['item-wrap']}>
      <span>{title}</span>
      <div className={styles['item-property']}>
        {(!subTitle||subTitle.length===0)?
        <div className={styles["item-row"]}>
          {children}
        </div>
        :
        subTitle.map((item,index)=>(
          <div key={index} className={styles["item-row"]}>
            <span>{item}</span>
            {children[index]}
          </div>
        ))}     
      </div>   
    </div>
  );
};

const FilterRow = ({data,onClick,state})=>{
  const [modelOn,setModelOn]=useState(state);
  const handleModelFilter = (e) =>{
    setModelOn(!modelOn);
    onClick("deviceQuery",data[0],data[1],modelOn,e);
  }
  return(
    <div onClick={handleModelFilter} className={styles['filter-row']}>
      <div className={styles['filter-row-name']} style={{color:`${modelOn ? "black":""}`}}>{data[0]}</div>
      <div className={styles['filter-row-num']} style={{background:`${modelOn ? "black":""}`}}>{data[1]}</div>
    </div>
  )
}

export default function NewTaskDevice() {
  const taskConfig = useRecoilValue(newTaskConfig);
  const setTaskConfig = useSetRecoilState(newTaskConfig);

  const [categoryOn,setCategoryOn]=useState(false);
  const [deviceList,setDeviceList]=useState([]);
  const [chartData,setChartData]=useState([]);
  const [deviceSize,setDeviceSize]=useState(0);
  const [dataSize,setDataSize]=useState(0);
  const [deviceDataCount,setDeviceDataCount]=useState(100000);
  const [algorithmToggle,setAlgorithmToggle]=useState(taskConfig.samplingParameter.algorithm);
  const [lossPriorityToggle,setLossPriorityToggle]=useState(taskConfig.samplingParameter.lossPriority);
  const [referenceRoundToggle,setReferenceRoundToggle]=useState(taskConfig.samplingParameter.referenceRound);

  const [nowStep,setNowStep]=useState(20);

  const handleCategoryFilter = (e) =>{
    e.stopPropagation()
    setDeviceList('');
  }

  useEffect(()=>{
    if(deviceList==''){
      useApi.post('ngp/dm/device/count/model',{
        "dataName":taskConfig.requiredData.toLowerCase(),
        "lastUpdatedWithin" : {
          "day" : 7,
          "hour" : "",
          "minute" : ""
        }
      }).then(res=>{
        setDeviceList(res.data);
      })
    }
    else{
      setCategoryOn(!categoryOn);
    }
  },[deviceList])

  useEffect(()=>{
    setChartData([]);
    if(taskConfig.deviceQuery.length==0){
      return;
    }
    useApi.post('ngp/dm/device/count/data',{
      "model":taskConfig.deviceQuery,
      "dataName":taskConfig.requiredData.toLowerCase(),
      "lastUpdatedWithin" : {
        "day" :  7,
        "hour" : "",
        "minute" : "" 
      }
    }).then(res=>{
      setChartData(res.data);
      const valueSum=Object.values(res.data).reduce((acc,cur)=>acc+cur,0);
      setDeviceDataCount(valueSum);
    })
  },[taskConfig.deviceQuery])

  const handleSetTaskConfig = (name,value) =>{
    if(name==='samplingTemperature'){
      setTaskConfig((prevData) => ({
        ...prevData,
        samplingParameter:{
          samplingTemperature:value,
          lossSelectionWeight:taskConfig.samplingParameter.lossSelectionWeight,
          recencyWeight:taskConfig.samplingParameter.recencyWeight,
          algorithm:taskConfig.samplingParameter.algorithm,
          lossPriority:taskConfig.samplingParameter.lossPriority,
          referenceRound:taskConfig.samplingParameter.referenceRound,
        },
      }));
    }
    else if(name==='lossSelectionWeight'){
      setTaskConfig((prevData) => ({
        ...prevData,
        samplingParameter:{
          samplingTemperature:taskConfig.samplingParameter.samplingTemperature,
          lossSelectionWeight:value,
          recencyWeight:taskConfig.samplingParameter.recencyWeight,
          algorithm:taskConfig.samplingParameter.algorithm,
          lossPriority:taskConfig.samplingParameter.lossPriority,
          referenceRound:taskConfig.samplingParameter.referenceRound,
        },
      }));
    }
    else if(name==='recencyWeight'){
      setTaskConfig((prevData) => ({
        ...prevData,
        samplingParameter:{
          samplingTemperature:taskConfig.samplingParameter.samplingTemperature,
          lossSelectionWeight:taskConfig.samplingParameter.lossSelectionWeight,
          recencyWeight:value,
          algorithm:taskConfig.samplingParameter.algorithm,
          lossPriority:taskConfig.samplingParameter.lossPriority,
          referenceRound:taskConfig.samplingParameter.referenceRound,
        },
      }));
    }
    else if(name==='algorithm'){
      setTaskConfig((prevData) => ({
        ...prevData,
        samplingParameter:{
          samplingTemperature:taskConfig.samplingParameter.samplingTemperature,
          lossSelectionWeight:taskConfig.samplingParameter.lossSelectionWeight,
          recencyWeight:taskConfig.samplingParameter.recencyWeight,
          algorithm:value,
          lossPriority:taskConfig.samplingParameter.lossPriority,
          referenceRound:taskConfig.samplingParameter.referenceRound,
        },
      }));
    }
    else if(name==='lossPriority'){
      setTaskConfig((prevData) => ({
        ...prevData,
        samplingParameter:{
          samplingTemperature:taskConfig.samplingParameter.samplingTemperature,
          lossSelectionWeight:taskConfig.samplingParameter.lossSelectionWeight,
          recencyWeight:taskConfig.samplingParameter.recencyWeight,
          algorithm:taskConfig.samplingParameter.algorithm,
          lossPriority:value,
          referenceRound:taskConfig.samplingParameter.referenceRound,
        },
      }));
    }
    else if(name==='referenceRound'){
      setTaskConfig((prevData) => ({
        ...prevData,
        samplingParameter:{
          samplingTemperature:taskConfig.samplingParameter.samplingTemperature,
          lossSelectionWeight:taskConfig.samplingParameter.lossSelectionWeight,
          recencyWeight:taskConfig.samplingParameter.recencyWeight,
          algorithm:taskConfig.samplingParameter.algorithm,
          lossPriority:taskConfig.samplingParameter.lossPriority,
          referenceRound:value,
        },
      }));
    }
    else{
      setTaskConfig((prevData) => ({
        ...prevData,
        [name]:value,
      }));
    }
  }     

  const handleSetTaskConfigDevice = (name,value,deviceSize,state,e) =>{
    e.stopPropagation();
    let data;
    if(state){
      const dataTemp=JSON.parse(JSON.stringify(taskConfig.deviceQuery))
      data=dataTemp.filter((item) => item !== value);
    }else{
      data=JSON.parse(JSON.stringify(taskConfig.deviceQuery))
      if (!data.includes(value)) {
        data.push(value);
      }
    }
    setTaskConfig((prevData) => ({
      ...prevData,
      [name]:data,
    }));
  }     

  const handleNext=()=>{
    let rejectText="";
    if(taskConfig.deviceQuery=="")rejectText+="- Device Filter\n"

    let rejectTextDeviceCount="";

    if((!parseInt(taskConfig.numOfTargetTrainingRequestDevicesPerRound)
      || !parseInt(taskConfig.numOfTargetTrainingResponseDevicesPerRound))
      && !parseInt(taskConfig.numOfTargetTestRequestDevices)
      && !parseInt(taskConfig.numOfTargetTestResponseDevices)
      ){
      rejectTextDeviceCount+="   - Devices Count의 현재 값으로 task가 실행 될 수 없습니다.\n"
    }
    if(parseInt(taskConfig.numOfTargetTrainingRequestDevicesPerRound)<parseInt(taskConfig.numOfTargetTrainingResponseDevicesPerRound)){
      rejectTextDeviceCount+="   - Training & Evaluation의 Target Deivces는\n     Target Response보다 같거나 커야 합니다.\n"
    }
    if(parseInt(taskConfig.numOfTargetTestRequestDevices)<parseInt(taskConfig.numOfTargetTestResponseDevices)){
      rejectTextDeviceCount+="   - Test의 Target Deivces는\n     Target Response보다 같거나 커야 합니다.\n"
    }
    if(parseInt(taskConfig.numOfTargetTrainingRequestDevicesPerRound) + parseInt(taskConfig.numOfTargetTestRequestDevices) > deviceDataCount
      || parseInt(taskConfig.numOfTargetTestRequestDevices) > deviceDataCount
      || parseInt(taskConfig.numOfTargetTrainingRequestDevicesPerRound) > deviceDataCount
    ){
      rejectTextDeviceCount+="   - Target Devices는\n     선택된 Devices Count보다 같거나 작아야 합니다.\n"
    }

    if(rejectTextDeviceCount!=""){
      rejectTextDeviceCount="- Device Count\n"+rejectTextDeviceCount;
      rejectText=rejectText+rejectTextDeviceCount;
    }

    if(taskConfig.samplingMethod=="")rejectText+="- Selector Method\n"

    if(taskConfig.samplingMethod=="pseudo-random"){
      if(deviceSize < (parseInt(taskConfig.numOfTargetTrainingRequestDevicesPerRound) * 2 + parseInt(taskConfig.numOfTargetTestRequestDevices)))
      rejectText+="- Selector Method\n      pseudo-random은 Training의 Target Device Per Round * 2 + Test의 Target Device Per Round 보다 작아야 합니다.\n"
    }

    if(rejectText=="") return true;
    else { 
      alert("다음 화면으로 진행 할 수 없습니다. 내용을 확인해 주세요.\n"+rejectText);
      return false;
    }
  }

  const disableFedUBS =
    Number(taskConfig?.samplingParameter?.samplingTemerature) === 0 ||
    Number(taskConfig?.samplingParameter?.lossSelectionWeight) === 0;

  const disablePseudoRandom =
    Number(taskConfig?.numOfTargetTrainingRequestDevicesPerRound) > (Number(deviceSize) / 2);

  useEffect(()=>{
    if(disableFedUBS && (taskConfig.samplingMethod==="FED_UBS" || taskConfig.samplingMethod==="fedUBS")){
      setTaskConfig(prev=>({...prev,samplingMethod:""}));
    }
  },[disableFedUBS, taskConfig.samplingMethod, setTaskConfig]);

  useEffect(()=>{
    if(disablePseudoRandom && (taskConfig.samplingMethod==="PSEUDO_RANDOM" || taskConfig.samplingMethod==="pseudo-random")){
      setTaskConfig(prev=>({...prev,samplingMethod:""}));
    }
  },[disablePseudoRandom, taskConfig.samplingMethod, setTaskConfig]);

  const pseudoRandomTitle = disablePseudoRandom ? "Training request가 선택된 device의 절반보다 큽니다" : "";
  const fedUBSTitle = disableFedUBS ? "sampling temperature 또는 lossSelectionWeight가 0입니다" : "";

  return (
    <div className={styles["NewTaskDevice-wrap"]}>
      <div className={styles["NewTaskDevice-header"]}>
        <span>New Task<p>&gt;</p>Device Clustering</span>
        <div className={styles["header-btn-wrap"]}>
          <NaviButton 
          to="/new-task-data-v2" 
          className={`${styles["header-btn"]} ${styles["header-btn-prev"]}`}>
            <p>&lt;</p>
            Data Setting
          </NaviButton>
          <NaviButton 
          to="/new-task-train" 
          className={`${styles["header-btn"]} ${styles["header-btn-next"]}`} 
          handleBtn={handleNext}>
            Next
          </NaviButton>
        </div>
      </div>
      <div className={styles["NewTaskDevice-body"]}>
        <div className={styles["body-main"]}>
          <div className={styles["main-dist"]}>
            <div className={styles["dist-head"]}>
              <span>Distribution</span>
              <div className={styles['info']}>
                <span className={styles['info-item']}>Device {deviceSize}</span>
                <span className={styles['info-item']}>Data {dataSize}</span>
              </div>
            </div>
            <div className={styles['dist-body']}>
              <div className={styles['dist-body-filter']}>
                <div className={styles['dist-body-device']}>
                  <span className={styles["filter-head"]}>Device Filter</span>
                  <div className={styles["filter-body"]}>
                    <div className={styles["filter-body-category"]}>
                      <span onClick={handleCategoryFilter} style={{color:`${categoryOn ? "black":""}`}}>Model</span>
                      <span onClick={(e)=>e.stopPropagation()}>MCC</span>
                      <span onClick={(e)=>e.stopPropagation()}>Chipset</span>
                    </div>
                    <hr/>
                    { categoryOn && <div className={styles["filter-body-model"]}>
                      {deviceList && Object.entries(deviceList).map((row)=>
                        <FilterRow categoryOn={categoryOn} 
                        onClick={handleSetTaskConfigDevice} 
                        state={taskConfig.deviceQuery.includes(row[0])}
                        data={row}/>
                      )}
                    </div>}
                  </div>
                </div>
                <div className={styles['dist-body-step']}>
                  <span>Data Size Scale</span>
                  <StepSlider
                  min={1}
                  max={20}
                  value={nowStep}
                  onChange={setNowStep}
                  />
                </div>
              </div>
              {chartData.length==0 ? 
              <div className={styles['chart-loader']}>Select Device Filter</div>:
              <DeviceClusteringChart 
              chartData={chartData}
              step={nowStep}
              onChange={(nowDeviceSize,nowDataSize)=>{
                if(typeof(nowDataSize)==='string'){
                  const [min,max]=nowDataSize.split('~').map(s=>parseInt(s.trim(),10))
                  setTaskConfig((prevData) => ({
                    ...prevData,
                    dataSizeGte : min,
                    dataSizeLte : max,
                  }));
                }
                setDeviceSize(nowDeviceSize)
                setDataSize(nowDataSize)
              }}
              />}
            </div>
          </div>
          <hr/>
          <div className={styles["main-wrap"]}>
            <div className={styles["main-count"]}>
              <div className={styles["main-count-row"]}>
                <span>Device Count Per Round</span>
                <span>Training & Evaluation</span>
                <span>Test</span>
              </div>
              <div className={styles["main-count-row"]}>
                <span>Request</span>
                <input type="number" placeholder='0' name="numOfTargetTrainingRequestDevicesPerRound" 
                value={taskConfig.numOfTargetTrainingRequestDevicesPerRound!=0 && taskConfig.numOfTargetTrainingRequestDevicesPerRound}
                onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
                <input type="number" placeholder='0' name="numOfTargetTestRequestDevices" 
                value={taskConfig.numOfTargetTestRequestDevices!=null && taskConfig.numOfTargetTestRequestDevices}
                onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
              </div>
              <div className={styles["main-count-row"]}>
                <span>Response</span>
                <input type="number" placeholder='0' name="numOfTargetTrainingResponseDevicesPerRound" 
                value={taskConfig.numOfTargetTrainingResponseDevicesPerRound!=0 && taskConfig.numOfTargetTrainingResponseDevicesPerRound}
                onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
                <input type="number" placeholder='0' name="numOfTargetTestResponseDevices" 
                value={taskConfig.numOfTargetTestResponseDevices!=null && taskConfig.numOfTargetTestResponseDevices}
                onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
              </div>
            </div>
          </div>
          <div className={styles["main-wrap"]}>
            <div className={styles["main-method"]}>
              <span>Device Selection Method</span>
              <div className={styles["method-btn-wrap"]}>
                <button
                className={`${styles["method-btn"]} ${taskConfig.samplingMethod=="FIXED" && styles["method-btn-clicked"] }`} 
                onClick={()=>{handleSetTaskConfig("samplingMethod","FIXED")}}>
                Fixed</button>
                <button
                className={`${styles["method-btn"]} ${taskConfig.samplingMethod=="RANDOM" && styles["method-btn-clicked"] }`} 
                onClick={()=>{handleSetTaskConfig("samplingMethod","RANDOM")}}>
                Random</button>
                <button
                disabled={disablePseudoRandom}
                title={pseudoRandomTitle}
                className={`${styles["method-btn"]} ${taskConfig.samplingMethod=="PSEUDO_RANDOM" && styles["method-btn-clicked"] } ${disablePseudoRandom && styles["method-btn-disabled"]}`}
                onClick={()=>{handleSetTaskConfig("samplingMethod","PSEUDO_RANDOM")}}>
                Pseudo-Random</button>
                <button
                disabled={disableFedUBS}
                title={fedUBSTitle}
                className={`${styles["method-btn"]} ${taskConfig.samplingMethod=="FED_UBS" && styles["method-btn-clicked"] } ${disableFedUBS && styles["method-btn-disabled"]}`}
                onClick={()=>{handleSetTaskConfig("samplingMethod","FED_UBS")}}>
                FedUBS</button>
                <button
                className={`${styles["method-btn"]} ${taskConfig.samplingMethod=="FED_LS" && styles["method-btn-clicked"] }`}
                onClick={()=>{handleSetTaskConfig("samplingMethod","FED_LS")}}>
                FedLS</button>
              </div>
              {(taskConfig.samplingMethod==='FED_UBS'||taskConfig.samplingMethod==='FED_LS')&&<div className={styles["method-btn-wrap"]}>
                
                {taskConfig.samplingMethod==='FED_UBS'?
                <MainItem title='FedUBS Detail' subTitle={['Loss Selection Weight','Sampling Temperature']}>
                <input className={styles['item-input']} type="number" placeholder='0' name='lossSelectionWeight'
                value={taskConfig.samplingParameter.lossSelectionWeight}
                onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
                <input className={styles['item-input']} ttype="number" placeholder='0' name='samplingTemperature'
                value={taskConfig.samplingParameter.samplingTemperature}
                onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
                </MainItem>:
                <MainItem title='FedLS Detail' subTitle={['Loss Selection Weight','Recency Weight','Algorithm','LossPriority','Reference Weight']}>
                  <input className={styles['item-input']} type="number" placeholder='0' name='lossSelectionWeight'
                  value={taskConfig.samplingParameter.lossSelectionWeight}
                  onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
                  <input className={styles['item-input']} type="number" placeholder='0' name='recencyWeight'
                  value={taskConfig.samplingParameter.recencyWeight}
                  onChange={(e)=>handleSetTaskConfig(e.target.name,e.target.value)}></input>
                  <div className={styles["toggle-btn-wrap"]}>
                    <button className={`${styles["toggle-btn"]} ${algorithmToggle=='globalMinLoss' && styles[ "toggle-btn-clicked"] }`} onClick={()=>{setAlgorithmToggle('globalMinLoss');handleSetTaskConfig('algorithm','globalMinLoss')}}>globalMinLoss</button>
                    <button className={`${styles["toggle-btn"]} ${algorithmToggle=='composite' && styles["toggle-btn-clicked"] }`} onClick={()=>{setAlgorithmToggle('composite');handleSetTaskConfig('algorithm','lossPriority')}}>lossPriority</button>
                    <button className={`${styles["toggle-btn"]} ${algorithmToggle=='halfLife' && styles["toggle-btn-clicked"] }`} onClick={()=>{setAlgorithmToggle('halfLife');handleSetTaskConfig('algorithm','referenceRound')}}>referenceRound</button>
                  </div>
                  <div className={styles["toggle-btn-wrap"]}>
                    <button className={`${styles["toggle-btn"]} ${lossPriorityToggle=='low' && styles[ "toggle-btn-clicked"] }`} onClick={()=>{setLossPriorityToggle('low');handleSetTaskConfig('lossPriority','low')}}>Low</button>
                    <button className={`${styles["toggle-btn"]} ${lossPriorityToggle=='high' && styles["toggle-btn-clicked"] }`} onClick={()=>{setLossPriorityToggle('high');handleSetTaskConfig('lossPriority','high')}}>High</button>
                  </div>
                  <div className={styles["toggle-btn-wrap"]}>
                    <button className={`${styles["toggle-btn"]} ${referenceRoundToggle=='latest' && styles[ "toggle-btn-clicked"] }`} onClick={()=>{setReferenceRoundToggle('latest');handleSetTaskConfig('referenceRound','latest')}}>Latest</button>
                    <button className={`${styles["toggle-btn"]} ${referenceRoundToggle=='earliest' && styles["toggle-btn-clicked"] }`} onClick={()=>{setReferenceRoundToggle('earliest');handleSetTaskConfig('referenceRound','earliest')}}>Earliest</button>
                  </div>
                </MainItem>}
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}